module.exports = __webpack_public_path__ + "img/f236462.webp";